<template>
  <div
    class="m-t d-flex justify-space-between"
  >
    <div class="footer-left">
      <slot name="left"></slot>
    </div>
    <div class="footer-right">
      <slot name="right"></slot>
    </div>
  </div>
</template>
<script setup lang="ts">
</script>
<style lang="scss" scoped>
:deep() {
  .m-t {
    margin-top: 12px;
  }

  .footer-left > .v-btn ~ .v-btn {
    margin-right: $gap-footer-button;
  }

  .footer-right > .v-btn ~ .v-btn {
    margin-left: $gap-footer-button;
  }
}
</style>
